import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=7e20fa35"
import script from "./footer.vue?vue&type=script&lang=babel"
export * from "./footer.vue?vue&type=script&lang=babel"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports